var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm.defaultCard ? '' : _vm.sortCard ? 'sort-card' : _vm.card ? 'card' : 'default-card'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }